import React from "react";
import { Link, useLocation } from "react-router-dom";
import { VARIANTS } from "./data";

// Floating switcher so the client can jump between the 3 mockups + current site.
const VariantSwitcher = () => {
  const { pathname } = useLocation();
  return (
    <div
      data-testid="variant-switcher"
      className="fixed bottom-5 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-1 rounded-full border border-white/15 bg-black/70 backdrop-blur-xl px-1.5 py-1.5 shadow-2xl"
    >
      {VARIANTS.map((v) => {
        const active = pathname === v.route;
        return (
          <Link
            key={v.route}
            to={v.route}
            data-testid={`switch-${v.route.replace("/", "")}`}
            className={`px-3.5 py-1.5 rounded-full text-[11px] font-semibold uppercase tracking-[0.12em] transition-colors ${
              active ? "bg-white text-black" : "text-white/70 hover:text-white"
            }`}
            style={{ fontFamily: "Montserrat, sans-serif" }}
          >
            {v.route.replace("/", "").toUpperCase()}
          </Link>
        );
      })}
      <span className="w-px h-5 bg-white/15 mx-1" />
      <Link
        to="/mockups"
        data-testid="switch-index"
        className="px-3.5 py-1.5 rounded-full text-[11px] font-semibold uppercase tracking-[0.12em] text-white/50 hover:text-white transition-colors"
        style={{ fontFamily: "Montserrat, sans-serif" }}
      >
        Comparar
      </Link>
    </div>
  );
};

export default VariantSwitcher;
